import { Component } from '@angular/core';
import { ModalService } from '../../../shared/components/modal/modal.service';
import { AbstractModal } from '../../../shared/components/modal/AbstractModal';

@Component({
  selector: 'ls-giftcard-help-modal',
  templateUrl: './giftcard-help-modal.component.html'
})
export class GiftcardHelpModalComponent extends AbstractModal {
  constructor(private modal: ModalService) {
    super();
  }

  public close(): void {
    this.modal.close();
  }
}
